/**
 * Mobile Search.
 * @format
 */

import React, { useState } from 'react';
import { safeCurrentLanguage, safeUrl } from '@services/drupal-services';
import { useSafeTranslate } from '@hooks/use-safe-translate';

/**
 * Mobile Search.
 */
const MobileSearch = (): JSX.Element => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const currentLanguage =
    safeCurrentLanguage() === 'en' ? '' : `${safeCurrentLanguage()}/`;
  const placeHolder = useSafeTranslate('Search Varian', true);
  const ariaLabel = useSafeTranslate('Search through site content', true);

  /**
   * Submit Search.
   */
  const submitSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const redirectUrl = safeUrl(
      `/${currentLanguage}search?crawler_varian_fullvarian-full%5Bquery%5D=${searchTerm}`
    );
    window.location.href = redirectUrl;
  };

  /**
   * Render.
   */
  return (
    <form
      className="mobile-search-box"
      noValidate
      role="search"
      onSubmit={(e) => submitSearch(e)}>
      <input
        type="search"
        name="mobile-search"
        placeholder={placeHolder ?? 'Search Varian'}
        aria-label={ariaLabel}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <i className="search-icon fas fa-search" aria-hidden="true" />
    </form>
  );
};
export default MobileSearch;
